/**
 * resolveActiveNavPath — pure helper for sidebar active-state logic.
 * Longest-match rule: among all paths that prefix-match the current pathname,
 * only the longest one is considered active. '/' is always exact-match only.
 */
export function resolveActiveNavPath(pathname: string, paths: string[]): string | null {
  let best: string | null = null;
  for (const path of paths) {
    if (path === '/') {
      if (pathname === '/') {
        if (best === null || path.length > best.length) best = path;
      }
      continue;
    }
    if (pathname === path || pathname.startsWith(path + '/')) {
      if (best === null || path.length > best.length) best = path;
    }
  }
  return best;
}
